import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
export default new Vuex.Store({
    state: {
        failsbtn: 0
    },
    mutations: {
        setfailsbtn(state,status){
            state.failsbtn = status
        }
    },
    actions: {
    },
    modules: {
    }
})


// WEBPACK FOOTER //
// ./src/store/index.js